(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["feature-card"] && !Shopify.designMode) return;
  try {
    (function () {

  /*
    =====================================================
    FEATURE CARD DRAG SCROLLER

    Key behaviour:

    Normal click:
      mouse down
      mouse up
      link opens normally

    Actual drag:
      mouse down
      move more than threshold
      slider moves
      resulting click is cancelled

    No pointerCapture.
    No pointer-events disabling.
    No prevention on normal clicks.
    =====================================================
  */


  function initialiseScroller(scroller) {

    if (!scroller) return;


    /*
      Avoid initialising same slider twice.
    */
    if (scroller.dataset.fcInitialised === 'true') {
      return;
    }


    scroller.dataset.fcInitialised = 'true';

    scroller.classList.add('fc-auto-scroller');


    /* ========================================
       START POSITION
    ======================================== */

    var firstCard =
      scroller.querySelector('.feature-card');


    if (
      firstCard &&
      firstCard.dataset.startPosition === 'right'
    ) {

      requestAnimationFrame(function () {

        scroller.scrollLeft =
          scroller.scrollWidth -
          scroller.clientWidth;

      });

    } else {

      scroller.scrollLeft = 0;

    }


    /* ========================================
       DRAG VARIABLES
    ======================================== */

    var mouseIsDown = false;

    var dragStarted = false;

    var startX = 0;

    var startingScrollLeft = 0;

    /*
      Only suppress the click immediately
      following a genuine drag.
    */
    var suppressClickUntil = 0;


    /*
      Physical mouse movement needed
      before a click becomes a drag.
    */
    var DRAG_THRESHOLD = 12;


    /*
      Slider movement speed.
    */
    var DRAG_SPEED = 1.2;



    /* ========================================
       MOUSE DOWN
    ======================================== */

    scroller.addEventListener(
      'mousedown',
      function (event) {

        /*
          Desktop only.
        */
        if (window.innerWidth <= 749) {
          return;
        }


        /*
          Only normal left mouse button.
        */
        if (event.button !== 0) {
          return;
        }


        mouseIsDown = true;

        dragStarted = false;

        startX = event.clientX;

        startingScrollLeft =
          scroller.scrollLeft;


        /*
          IMPORTANT:

          We DO NOT use preventDefault here.

          Therefore normal links can still
          receive their normal browser click.
        */

      }
    );



    /* ========================================
       MOUSE MOVE
    ======================================== */

    window.addEventListener(
      'mousemove',
      function (event) {

        if (!mouseIsDown) {
          return;
        }


        var deltaX =
          event.clientX - startX;


        /*
          Start dragging ONLY after genuine
          horizontal movement.
        */
        if (
          !dragStarted &&
          Math.abs(deltaX) >= DRAG_THRESHOLD
        ) {

          dragStarted = true;

          scroller.classList.add(
            'is-dragging'
          );

        }


        if (!dragStarted) {
          return;
        }


        /*
          Prevent text selection / native drag
          ONLY after drag has started.
        */
        event.preventDefault();


        scroller.scrollLeft =
          startingScrollLeft -
          (deltaX * DRAG_SPEED);

      },
      {
        passive: false
      }
    );



    /* ========================================
       END DRAG
    ======================================== */

    function endDrag() {

      if (!mouseIsDown) {
        return;
      }


      mouseIsDown = false;


      if (dragStarted) {

        /*
          Browser fires a click immediately
          after mouseup.

          Suppress only that click.
        */
        suppressClickUntil =
          Date.now() + 250;

      }


      dragStarted = false;


      scroller.classList.remove(
        'is-dragging'
      );

    }


    window.addEventListener(
      'mouseup',
      endDrag
    );


    window.addEventListener(
      'blur',
      endDrag
    );



    /* ========================================
       CLICK HANDLING
    ======================================== */

    scroller.addEventListener(
      'click',
      function (event) {

        /*
          Check only actual links.
        */
        var link =
          event.target.closest('a');


        if (!link) {
          return;
        }


        /*
          This was the click generated directly
          after dragging the carousel.

          Cancel it.
        */
        if (
          Date.now() <
          suppressClickUntil
        ) {

          event.preventDefault();

          event.stopPropagation();

          suppressClickUntil = 0;

          return;
        }


        /*
          Otherwise:

          DO NOTHING.

          Browser handles:

          <a href="...">

          naturally.
        */

      },
      true
    );



    /* ========================================
       PREVENT NATIVE IMAGE DRAG
    ======================================== */

    scroller.addEventListener(
      'dragstart',
      function (event) {

        if (
          event.target.matches(
            '.feature-card__image'
          )
        ) {

          event.preventDefault();

        }

      }
    );

  }



  /* ========================================
     FIND FEATURE CARD ROWS
  ======================================== */

  function initialiseAllFeatureCards() {

    var cards =
      document.querySelectorAll(
        '.feature-card'
      );


    if (!cards.length) {
      return;
    }


    var parents = new Set();


    cards.forEach(
      function (card) {

        if (card.parentElement) {

          parents.add(
            card.parentElement
          );

        }

      }
    );


    parents.forEach(
      function (parent) {

        initialiseScroller(parent);

      }
    );

  }



  /* ========================================
     INITIAL LOAD
  ======================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllFeatureCards
    );

  } else {

    initialiseAllFeatureCards();

  }



  /* ========================================
     SHOPIFY THEME EDITOR
  ======================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      initialiseAllFeatureCards();

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function () {

      initialiseAllFeatureCards();

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
